"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintableLivingStreetIcon = PrintableLivingStreetIcon;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PrintableLivingStreetIcon({
  color,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_renderer.Svg, _extends({
    viewBox: "0.5 0 32 32"
  }, props), /*#__PURE__*/_react.default.createElement(_renderer.Path, {
    d: "M16 0c-8.822 0-16 7.18-16 16.002s7.178 15.998 16 15.998 16-7.176 16-15.998-7.178-16.002-16-16.002zM16 30.56c-8.030 0-14.56-6.532-14.56-14.558 0-8.030 6.532-14.56 14.56-14.56s14.56 6.532 14.56 14.56c0 8.028-6.53 14.558-14.56 14.558zM14.566 13.178c0 2.172-1.39 3.716-4.954 7.278h5.23l-0.192 1.338h-6.86v-1.27c4.098-4.274 5.106-5.384 5.106-7.276 0-1.214-0.782-1.928-1.91-1.928-0.972 0-1.614 0.382-2.364 1.27l-1.072-0.838c0.934-1.162 2.064-1.752 3.524-1.752 2.136 0 3.492 1.372 3.492 3.178zM24.45 15.992c0 3.856-1.286 6.008-3.89 6.008s-3.888-2.152-3.888-6.008 1.282-5.992 3.886-5.992 3.892 2.152 3.892 5.992zM18.336 15.992c0 3.418 0.766 4.74 2.222 4.74 1.446 0 2.222-1.322 2.222-4.74 0-3.402-0.778-4.722-2.222-4.722-1.456 0-2.222 1.32-2.222 4.722z",
    fill: color
  }));
}